export const INTX_GROUPS = {
  SIGNALIZED: "SIGNALIZED",
  UNSIGNALIZED: "UNSIGNALIZED",
  INTERCHANGE: "INTERCHANGE",
  OTHER: "OTHER",
};

const AT_GRADE_INTX_TYPES = {
  // Shared intersection types
  ALL_WAY_STOP: "ALL_WAY_STOP",
  SIGNAL: "SIGNAL",
  DLT: "DLT",
  MUT: "MUT",
  RCUT_SIGNALIZED: "RCUT_SIGNALIZED",
  RCUT_UNSIGNALIZED: "RCUT_UNSIGNALIZED",
  TWSC: "TWSC",

  // Life Cycle Cost intersection types
  CGT: "CGT",
  JUGHANDLE: "JUGHANDLE",
  ONE_LANE_ROUNDABOUT: "ONE_LANE_ROUNDABOUT",
  QUADRANT_ROADWAY: "QUADRANT_ROADWAY",
  TWO_LANE_ROUNDABOUT: "TWO_LANE_ROUNDABOUT",

  // CAP-X intersection types
  BOWTIE: "BOWTIE",
  CTO: "CTO",
  CGT_N: "CGT_N",
  CGT_W: "CGT_W",
  CGT_E: "CGT_E",
  CGT_S: "CGT_S",
  ECHELON: "ECHELON",
  FDLT: "FDLT",
  PDLT: "PDLT",
  PMUT: "PMUT",
  QR_NE: "QR_NE",
  QR_NW: "QR_NW",
  QR_SE: "QR_SE",
  QR_SW: "QR_SW",
  SPLIT_INTX: "SPLIT_INTX",
  MINI_RBT_50: "MINI_RBT_50",
  MINI_RBT_75: "MINI_RBT_75",
  ROUNDABOUT: "ROUNDABOUT",
};

const RAMP_TERMINAL_INTX_TYPES = {
  // Shared intersection types
  DDI: "DDI",
  SINGLE_POINT_DIAMOND: "SINGLE_POINT_DIAMOND",

  // Life Cycle Cost intersection types
  DIAMOND_WITH_SIGNALS: "DIAMOND_WITH_SIGNALS",
  DIAMOND_WITH_STOP_CONTROL: "DIAMOND_WITH_STOP_CONTROL",
  DIAMOND_WITH_ONE_LANE_ROUNDABOUTS: "DIAMOND_WITH_ONE_LANE_ROUNDABOUTS",
  DIAMOND_WITH_TWO_LANE_ROUNDABOUTS: "DIAMOND_WITH_TWO_LANE_ROUNDABOUTS",

  // CAP-X intersection types
  TRAD_DIAMOND: "TRAD_DIAMOND",
  CONTRAFLOW_LEFT: "CONTRAFLOW_LEFT",
  DLT_INTERCHANGE: "DLT_INTERCHANGE",
  DOUBLE_RBT: "DOUBLE_RBT",
  PARTIAL_CLOVERLEAF_A: "PARTIAL_CLOVERLEAF_A",
  PARTIAL_CLOVERLEAF_B: "PARTIAL_CLOVERLEAF_B",
  SINGLE_RBT: "SINGLE_RBT",
};

export const INTX_TYPES = {
  ...AT_GRADE_INTX_TYPES,
  ...RAMP_TERMINAL_INTX_TYPES,
  OTHER: "OTHER",
};

export const INTX_TYPE_TO_LABEL = {
  [INTX_TYPES.OTHER]: "Other",

  // signalized
  [INTX_TYPES.SIGNAL]: "Conventional Signal",
  [INTX_TYPES.BOWTIE]: "Bowtie",
  [INTX_TYPES.CTO]: "Center Turn Overpass",
  [INTX_TYPES.CGT_N]: "Continuous Green-T (N)",
  [INTX_TYPES.CGT_W]: "Continuous Green-T (W)",
  [INTX_TYPES.CGT_E]: "Continuous Green-T (E)",
  [INTX_TYPES.CGT_S]: "Continuous Green-T (S)",
  [INTX_TYPES.CGT]: "Continuous Green-T",
  [INTX_TYPES.DLT]: "Displaced left turn",
  [INTX_TYPES.ECHELON]: "Echelon",
  [INTX_TYPES.FDLT]: "Full Displaced Left Turn",
  [INTX_TYPES.JUGHANDLE]: "Jughandle",
  [INTX_TYPES.MUT]: "Median U-turn",
  [INTX_TYPES.PDLT]: "Partial Displaced Left Turn",
  [INTX_TYPES.PMUT]: "Partial Median U-turn",
  [INTX_TYPES.QR_NE]: "Quadrant Roadway N-E",
  [INTX_TYPES.QR_NW]: "Quadrant Roadway N-W",
  [INTX_TYPES.QR_SE]: "Quadrant Roadway S-E",
  [INTX_TYPES.QR_SW]: "Quadrant Roadway S-W",
  [INTX_TYPES.QUADRANT_ROADWAY]: "Quadrant Roadway",
  [INTX_TYPES.RCUT_SIGNALIZED]: "Restricted Crossing U-turn - Signalized",
  [INTX_TYPES.SPLIT_INTX]: "Split Intersection",

  // unsignalized
  [INTX_TYPES.ONE_LANE_ROUNDABOUT]: "One-Lane Roundabout",
  [INTX_TYPES.TWO_LANE_ROUNDABOUT]: "Two-Lane Roundabout",
  [INTX_TYPES.MINI_RBT_50]: "50 Mini Roundabout",
  [INTX_TYPES.MINI_RBT_75]: "75 Mini Roundabout",
  [INTX_TYPES.ROUNDABOUT]: "Roundabout",
  [INTX_TYPES.ALL_WAY_STOP]: "All-Way Stop Control",
  [INTX_TYPES.TWSC]: "Two-Way Stop Control",
  [INTX_TYPES.RCUT_UNSIGNALIZED]: "Restricted Crossing U-turn - Unsignalized",

  // interchanges
  [INTX_TYPES.TRAD_DIAMOND]: "Traditional Diamond",
  [INTX_TYPES.DIAMOND_WITH_SIGNALS]: "Diamond (D4) with Conventional Signals",
  [INTX_TYPES.DIAMOND_WITH_STOP_CONTROL]: "Diamond (D4) with Stop Control",
  [INTX_TYPES.DIAMOND_WITH_ONE_LANE_ROUNDABOUTS]:
    "Diamond with One-lane Roundabouts",
  [INTX_TYPES.DIAMOND_WITH_TWO_LANE_ROUNDABOUTS]:
    "Diamond with Two-lane Roundabouts",
  [INTX_TYPES.CONTRAFLOW_LEFT]: "Contraflow Left",
  [INTX_TYPES.DLT_INTERCHANGE]: "Displaced Left Turn Interchange",
  [INTX_TYPES.DDI]: "Diverging Diamond",
  [INTX_TYPES.DOUBLE_RBT]: "Double Roundabout",
  [INTX_TYPES.PARTIAL_CLOVERLEAF_A]: "Partial Cloverleaf A",
  [INTX_TYPES.PARTIAL_CLOVERLEAF_B]: "Partial Cloverleaf B",
  [INTX_TYPES.SINGLE_POINT_DIAMOND]: "Single Point Diamond",
  [INTX_TYPES.SINGLE_RBT]: "Single Roundabout Interchange",
};

export const DIRECTIONS = {
  EASTBOUND: "eastbound",
  WESTBOUND: "westbound",
  NORTHBOUND: "northbound",
  SOUTHBOUND: "southbound",
};

export const ORIENTATIONS = {
  EAST_WEST: "EAST_WEST",
  NORTH_SOUTH: "NORTH_SOUTH",
};

export const ANALYSIS_TYPES = {
  AT_GRADE_INTERSECTION: "AT_GRADE_INTERSECTION",
  RAMP_TERMINAL_INTERSECTION: "RAMP_TERMINAL_INTERSECTION",
};

export const FACILITY_TYPE = {
  RURAL_INTERSTATE: "RURAL_INTERSTATE",
  RURAL_PRINCIPAL_ARTERIAL: "RURAL_PRINCIPAL_ARTERIAL",
  RURAL_MINOR_ARTERIAL: "RURAL_MINOR_ARTERIAL",
  RURAL_MAJOR_COLLECTOR: "RURAL_MAJOR_COLLECTOR",
  RURAL_MINOR_COLLECTOR: "RURAL_MINOR_COLLECTOR",
  URBAN_INTERSTATE: "URBAN_INTERSTATE",
  URBAN_OTHER_FRWY_EXPWY: "URBAN_OTHER_FRWY_EXPWY",
  URBAN_PRINCIPAL_ARTERIAL: "URBAN_PRINCIPAL_ARTERIAL",
  URBAN_MINOR_ARTERIAL: "URBAN_MINOR_ARTERIAL",
};

export const NO_CURRENT_INTERSECTION = "NO_CURRENT_INTERSECTION";

export const ADJUSTMENT_FACTORS = {
  UTAF: 0.8,
  LTAF: 0.95,
  RTAF: 0.85,
  TRUCK_PCE: 2,
  TWO_PHASE_SIGNAL_CLV_SUM_LIMIT: 1800,
  THREE_PHASE_SIGNAL_CLV_SUM_LIMIT: 1750,
  FOUR_PHASE_SIGNAL_CLV_SUM_LIMIT: 1700,
};

/**
 *
 * @param {string} currentIntersection
 * @param {string} analysisType
 * @param {string} intxType
 * @returns array of Required SPF base intersection types, or undefined if there is no required intersection
 */
export const getSPFBaseIntersections = ({
  currentIntersection,
  analysisType,
  intxType,
}) => {
  const getIntersectionMapper = () => {
    switch (currentIntersection) {
      case NO_CURRENT_INTERSECTION:
        return analysisType === ANALYSIS_TYPES.AT_GRADE_INTERSECTION
          ? {
              [INTX_TYPES.TWO_LANE_ROUNDABOUT]: [
                INTX_TYPES.SIGNAL,
                INTX_TYPES.TWSC,
              ],
              [INTX_TYPES.DLT]: [INTX_TYPES.SIGNAL],
              [INTX_TYPES.MUT]: [INTX_TYPES.SIGNAL],
              [INTX_TYPES.RCUT_SIGNALIZED]: [INTX_TYPES.SIGNAL],
              [INTX_TYPES.RCUT_UNSIGNALIZED]: [INTX_TYPES.TWSC],
              [INTX_TYPES.CGT]: [INTX_TYPES.SIGNAL],
              [INTX_TYPES.JUGHANDLE]: [INTX_TYPES.SIGNAL],
              [INTX_TYPES.QUADRANT_ROADWAY]: [INTX_TYPES.SIGNAL],
              [INTX_TYPES.OTHER]: [
                INTX_TYPES.SIGNAL,
                INTX_TYPES.TWSC,
                INTX_TYPES.ALL_WAY_STOP,
              ],
            }
          : {
              [INTX_TYPES.DDI]: [INTX_TYPES.DIAMOND_WITH_SIGNALS],
              [INTX_TYPES.SINGLE_POINT_DIAMOND]: [
                INTX_TYPES.DIAMOND_WITH_SIGNALS,
              ],
              [INTX_TYPES.DIAMOND_WITH_TWO_LANE_ROUNDABOUTS]: [
                INTX_TYPES.DIAMOND_WITH_SIGNALS,
                INTX_TYPES.DIAMOND_WITH_STOP_CONTROL,
              ],
              [INTX_TYPES.OTHER]: [
                INTX_TYPES.DIAMOND_WITH_SIGNALS,
                INTX_TYPES.DIAMOND_WITH_STOP_CONTROL,
              ],
            };
      case INTX_TYPES.TWSC:
        return {};
      case INTX_TYPES.ALL_WAY_STOP:
        return {
          [INTX_TYPES.TWO_LANE_ROUNDABOUT]: [
            INTX_TYPES.SIGNAL,
            INTX_TYPES.TWSC,
          ],
          [INTX_TYPES.DLT]: [INTX_TYPES.SIGNAL],
          [INTX_TYPES.MUT]: [INTX_TYPES.SIGNAL],
          [INTX_TYPES.RCUT_SIGNALIZED]: [INTX_TYPES.SIGNAL],
          [INTX_TYPES.RCUT_UNSIGNALIZED]: [INTX_TYPES.TWSC],
          [INTX_TYPES.CGT]: [INTX_TYPES.SIGNAL],
          [INTX_TYPES.JUGHANDLE]: [INTX_TYPES.SIGNAL],
          [INTX_TYPES.QUADRANT_ROADWAY]: [INTX_TYPES.SIGNAL],
        };
      case INTX_TYPES.SIGNAL:
        return {
          [INTX_TYPES.RCUT_UNSIGNALIZED]: [INTX_TYPES.TWSC],
        };
      case INTX_TYPES.DIAMOND_WITH_STOP_CONTROL:
        return {
          [INTX_TYPES.DDI]: [INTX_TYPES.DIAMOND_WITH_SIGNALS],
          [INTX_TYPES.SINGLE_POINT_DIAMOND]: [INTX_TYPES.DIAMOND_WITH_SIGNALS],
        };
      case INTX_TYPES.DIAMOND_WITH_SIGNALS:
        return {};
      default:
        throw new Error(
          `Cannot find base intersections for currentIntersection ${currentIntersection}`
        );
    }
  };
  return getIntersectionMapper()?.[intxType];
};
